export default {
  GET_ALL: `#graphql
  query getFeedbacks($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getFeedbacks(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init: $init, final: $final)
    {
      docs {
        feedback
        description
        additionals
        type
        status
        createdBy
        createdAt
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }
  }`,

  NEW: `#graphql
  mutation NewFeedback($feedback: FeedbackInput!) {
    newFeedback(input: $feedback)
    {
      feedback
      description
      additionals
      type
      status
      createdBy
    }
  }`,

  UPDATE: `#graphql
  mutation UpdateFeedback($feedback: String!, $feedbackUpdate: FeedbackUpdateInput!) {
    updateFeedback(feedback: $feedback, feedbackUpdate: $feedbackUpdate)
    {
      feedback
    }
  }`,

  DELETE: `#graphql
  mutation DeleteFeedback($feedback: String!) {
    deleteFeedback(feedback: $feedback)
    {
      feedback
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/feedback.js